import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ApartmentService } from '../../../../../_services/apartments/apartment.service'
import { FormControl, FormGroup,FormBuilder,  ReactiveFormsModule, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { UploadFileService } from 'src/app/_services/UploadFile/upload-file.service';
import { Subscription } from 'rxjs';
import { Guid } from 'guid-typescript';

type Q = {
  id: string;
  question: string;
  answer: '' | 'yes' | 'no',
  comment?: string;
  images?:string[];
  __invalid?: boolean; 

}
 

interface Room {
  room_ID: string;
  room_Name: string;
  room_Devices: [];
}
@Component({
  selector: 'app-forth-step',
  templateUrl: './forth-step.component.html',
  styleUrls: ['./forth-step.component.scss']
})
export class ForthStepComponent {
  Qdamage:boolean=true;
  onDescriptionChange(description: string): void {
    this.Qdamage = description.length===0;
  }
  /** apartmentCurrentlyExisting */
  apartmentCurrentlyExisting: Array<string> = ['Yes', 'No']
  /** CreateapartmentCurrentlyExisting */
  CreateapartmentCurrentlyExisting: string = 'Yes';
  /** checkedstripe */
  checkedstripe: boolean = true;
  checkedOnline: boolean = true;
  checkSecurityDeposit :boolean = true

  /** checkedPayPal */
  checkedPayPal: boolean = true;
  /** checkedCash */
  checkedCash: boolean = true;
  /** apartment_Gas_Meter_Consumption */
  apartment_Gas_Meter_Consumption: boolean = false
  /** Labelfield */
  Labelfield: any = { text1: 'Input Field Name', text2: 'Input Field Content' };
  /** PostBackupInfo */
  PostBackupInfo!: FormGroup;
  /** inputField */
  inputField: Array<any> = []
  /** selectedContract */
  selectedContract: any;
  subscriptions:Subscription[] = [];
  romeDetails : any

  /** addApartment */
  @Input() addApartment: string = '';
  /** id */
  @Input() id: string = ''
  /** jumbToNextSteb */
  @Output() jumbToNextSteb = new EventEmitter<void>();
  /** jumbToPrevSteb */
  @Output() jumbToPrevSteb = new EventEmitter<void>();

  apt_UUID: any;
 Rooms_Devices : any[]=[];
 Devices: Array<any> = [];
 selectedRooms: any;

  constructor(
    public _ApartmentService: ApartmentService,
    private router: Router,
    private messageService: MessageService,
    private uploadService: UploadFileService,
    private _ActivatedRoute: ActivatedRoute,
       private fb: FormBuilder,

  ) {
    this.apt_UUID = localStorage.getItem('Apartment_ID');
    const data = localStorage.getItem('generalInfoForm');
    if (data !== null) {
      let parsedData = JSON.parse(data);
      this.selectedRooms = parsedData.apartment_BedRoomsNo
    }


   }


  idParamterEdit:any=""
  ngOnInit() {
    this.idParamterEdit = this._ActivatedRoute.snapshot.params['id']

     if(this.addApartment !="add new apartments" ){
      this.edit="EditForm"
      this.bindCreatePostBackupInfo();
      this.getApartmentDetails();
      // this.initializeRooms();

     }else{
      this.bindCreatePostBackupInfo();
      this.getLocalStorage();
      this.initializeRooms();
     }

     this.Qdamage=true;

     ///////////////////////
     this.form = this.fb.group({
      description: ['', Validators.required]
    });

      

  }
  edit =""
  aprt_details_Edit :any
  wifi:any
  getApartmentDetails() {
    this.subscriptions.push(this._ApartmentService.getApartDetail(this.idParamterEdit).subscribe((res) => {
console.log(res)
this.applyHandoverResponse(res?.handover),
// this.applyHandover(res.handover)
      this.aprt_details_Edit = res.apartment_Backup_Info
      this.wifi = res.rent_Rules
      this.selectedRooms=res.apartment_Basic_Info.apartment_Rooms.length
       this.PostBackupInfo.patchValue(res.apartment_Backup_Info);
       this.inputField=res.apartment_Backup_Info["apartment_Addons_Fields"]
       if(res.apartment_Backup_Info["apartment_has_Damages"]){
       console.log(res.apartment_Backup_Info["apartment_has_Damages"])
        this.CreateapartmentCurrentlyExisting = 'Yes'
       }else{
       console.log(res.apartment_Backup_Info["apartment_has_Damages"])

         this.CreateapartmentCurrentlyExisting = 'No'
       }
       console.log(res.apartment_Backup_Info["apartment_has_Damages"])
       console.log(this.CreateapartmentCurrentlyExisting)
       
      //  if(res.backup_Info["payment_Methods"][0].payment_Method_Name=='false'){
      //   this.checkedOnline=false
      //  }else{
      //   this.checkedOnline=true

      //  }
      //  if(res.backup_Info["payment_Methods"][1].payment_Method_Name=='false'){
      //   this.checkedCash=false
      //  }else{
      //   this.checkedCash=true

      //  }
      // this.checkedOnline = Boolean(res.backup_Info["payment_Methods"][0].payment_Method_Name)
      //  this.checkedPayPal =  Boolean(res.backup_Info["payment_Methods"][1].payment_Method_Name)
     //  this.checkedCash =  Boolean(res.backup_Info["payment_Methods"][1].payment_Method_Name)
     }))


  }
  // get  local storage
  getLocalStorage(): void {
    const data = localStorage.getItem("PostBackupInfo");
    this.romeDetails = JSON.parse(localStorage.getItem('apartmentResponse')!);
    this.storedImages =[]


    this.storedImages = JSON.parse(localStorage.getItem("imagesAPT11")||'{}');

    if (data !== null) {
      let parsedData = JSON.parse(data);
      this.PostBackupInfo.patchValue(parsedData);

      this.CreateapartmentCurrentlyExisting = parsedData.CreateapartmentCurrentlyExisting;
      this.selectedContract = { 'url': parsedData.apartment_Damages_Imgs[0] }
      // payment till we make finale one
      this.checkedOnline = Boolean(parsedData.apartment_Is_Online_Payment);
      this.checkSecurityDeposit = Boolean(parsedData.apartment_Is_Security_Payment);
      this.checkedCash = Boolean(parsedData.apartment_Is_Cash_Payment);




    }
  }

  DoyouapartmentCurrentlyExisting(value: any) {
    this.CreateapartmentCurrentlyExisting = value.target.value
    let check
    this.CreateapartmentCurrentlyExisting == 'Yes' ? check = true : check = false
    this.PostBackupInfo.get('apartment_has_Damages')?.setValue(check);
  }

  /**
   * onUploadContract
   * upload photo in single file uploader uploadService
   * @param event
   */
  onUploadContract(event: any): void {
    const file = event.target.files[0];

    const selectedFile = event.target.files[0];
    const formData = new FormData();
    formData.append('fileData', selectedFile, selectedFile.name);

    if (file) {
      this.subscriptions.push( this.uploadService.uploadSingleFile(formData).subscribe((img: any) => {
        file.url = URL.createObjectURL(file);
        this.selectedContract = file;
        this.PostBackupInfo.get('apartment_Damages_Imgs')?.patchValue(
          [ img[0].file_Path]);
        this.messageService.add({ severity: 'success', summary: 'Success', detail: `damage Upload Successfuly` });
      }, (err) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: `Please try again` });
      }));

    }
  }

  /**
   * submitForthForm
   * @description Emit an event to the parent component
   * @returns void
   */
  submitForthForm(): void {
    this.jumbToNextSteb.emit();
  }

  /**
 * PrevPage
 * @description Emit an event to the parent component
 * @returns void
 */
  PrevPage(): void {
    this.jumbToPrevSteb.emit();


    const payloadData: any = {
      ...this.PostBackupInfo.value,
      "apartment_Addons_Fields": this.inputField,
      "payment_Methods":
        [
          { "payment_Method_Name": String(this.checkedOnline) },
          // { "payment_Method_Name": String(this.checkedPayPal) },
          { "payment_Method_Name": String(this.checkedCash) }
        ]
    }

    localStorage.setItem("PostBackupInfo", JSON.stringify({ ...payloadData, CreateapartmentCurrentlyExisting: this.CreateapartmentCurrentlyExisting }))

  }
  bindCreatePostBackupInfo(): void {
    this.PostBackupInfo = new FormGroup({
      'apartment_ID':new FormControl(JSON.parse(localStorage.getItem('apartmentResponse')!).uuid),
      'apartment_Electricity_Meter_No': new FormControl(''),
      'apartment_Electricity_Meter_Consumption': new FormControl(''),
      'apartment_Water_Meter_No': new FormControl(''),
      'apartment_Water_Meter_Consumption': new FormControl(''),
      'apartment_Gas_Meter_No': new FormControl(''),
      'apartment_Gas_Meter_Consumption': new FormControl(''),
      'apartment_has_Damages': new FormControl(true),
      'apartment_Damages_Imgs': new FormControl([]),
      'apartment_General_Description': new FormControl(''),
      'apartment_Description': new FormControl(''),
      'apartment_Is_Online_Payment': new FormControl(true),
      'apartment_Is_Security_Payment': new FormControl(true),
      'apartment_Is_Cash_Payment': new FormControl(true)
    })


  }
  room_Devices : any[] = [];
  rooms: any[] = [];
  public roomIndexValue :any;

roomsHandover:any[]=[]
getbedrooms:any[]=[]
  initializeRooms() {

    this._ApartmentService.getRoomDevices(JSON.parse(localStorage.getItem('apartmentResponse')!).uuid).subscribe({
      next:(res)=>{
        console.log(res)
        this.roomsHandover=res
        /////////////////////////////////////////
         const bedroomKeywords = ['single', 'double', 'trible', 'shared'];
  this.getbedrooms = this.roomsHandover
    .filter((room: any) => {
      const name = room.room_Name?.toLowerCase() || '';
      return bedroomKeywords.some(type => name.includes(type));
    })
    .map((room: any) => ({
      room_ID: room.room_ID,
      room_Name: room.room_Name,
      place_Images: <string[]>[],
      questions: this.deepClone(this.roomQuestions.bedroom) // ⬅️ نسخة مستقلة من الأسئلة لكل غرفة
    }));
        //////////////////////////////////////////
        console.log('🛏️ Filtered Bedrooms:', this.getbedrooms);
      //  this.Rooms_Devices=res;
       const kitchen = {
        room_ID: Guid.create().toString(),
        room_Name: 'Kitchen',
        room_Devices: [
          { device_Name: 'Fridge', is_Checked: false, device_Description: '' },
          { device_Name: 'Oven ', is_Checked: false, device_Description: '' },
          { device_Name: 'Microwave', is_Checked: false, device_Description: '' },
          { device_Name: 'kitchen cabinet', is_Checked: false, device_Description: '' },

        { device_Name: 'Mold', is_Checked: false, device_Description: '' },
        { device_Name: 'Devices', is_Checked: false, device_Description: '' },
        { device_Name: 'Walls', is_Checked: false, device_Description: 'mold' },

        { device_Name: 'Floor', is_Checked: false, device_Description: '' },
        { device_Name: 'Cleaning', is_Checked: false, device_Description: '' }
        ]
      };
      const Bathroom = {
        room_ID: Guid.create().toString(),
        room_Name: 'Bathroom',
        room_Devices: [
          { device_Name: 'Sink', is_Checked: false, device_Description: '' },
        { device_Name: 'Toilet', is_Checked: false, device_Description: '' },
        { device_Name: 'Shower', is_Checked: false, device_Description: '' },
        { device_Name: 'Mirror', is_Checked: false, device_Description: '' },
        { device_Name: 'Towel Rack', is_Checked: false, device_Description: '' },

        { device_Name: 'Mold', is_Checked: false, device_Description: '' },
        { device_Name: 'Devices', is_Checked: false, device_Description: '' },
        { device_Name: 'Walls', is_Checked: false, device_Description: 'mold' },

        { device_Name: 'Floor', is_Checked: false, device_Description: '' },
        { device_Name: 'Cleaning', is_Checked: false, device_Description: '' }
        ]
      };
      if(this.addApartment !="add new apartments" ){

        this.Rooms_Devices=res;
      


       }else{

        this.Rooms_Devices=[...res,kitchen,Bathroom];
       }


      }
    })
  }
  addRoom(roomName: string): void {
    if(roomName==='Kitchen'){
      this.Rooms_Devices.push({
        room_ID: Guid.create().toString(),
        room_Name: 'Kitchen',
        room_Devices: [
          { device_Name: 'Fridge', is_Checked: false, device_Description: '' },
          { device_Name: 'Oven ', is_Checked: false, device_Description: '' },
          { device_Name: 'Microwave', is_Checked: false, device_Description: '' },
          { device_Name: 'kitchen cabinet', is_Checked: false, device_Description: '' },

        { device_Name: 'Mold', is_Checked: false, device_Description: '' },
        { device_Name: 'Devices', is_Checked: false, device_Description: '' },
        { device_Name: 'Walls', is_Checked: false, device_Description: 'mold' },

        { device_Name: 'Floor', is_Checked: false, device_Description: '' },
        { device_Name: 'Cleaning', is_Checked: false, device_Description: '' }
        ]
      });
    }else if(roomName==='Bathroom'){
      this.Rooms_Devices.push({
      room_ID: Guid.create().toString(),
      room_Name: 'Bathroom',
      room_Devices: [
        { device_Name: 'Sink', is_Checked: false, device_Description: '' },
      { device_Name: 'Toilet', is_Checked: false, device_Description: '' },
      { device_Name: 'Shower', is_Checked: false, device_Description: '' },
      { device_Name: 'Mirror', is_Checked: false, device_Description: '' },
      { device_Name: 'Towel Rack', is_Checked: false, device_Description: '' },

      { device_Name: 'Mold', is_Checked: false, device_Description: '' },
      { device_Name: 'Devices', is_Checked: false, device_Description: '' },
      { device_Name: 'Walls', is_Checked: false, device_Description: 'mold' },

      { device_Name: 'Floor', is_Checked: false, device_Description: '' },
      { device_Name: 'Cleaning', is_Checked: false, device_Description: '' }
      ]
    });
    }

  }

   shouldDisplay(): boolean {
    const roomNames = this.Rooms_Devices.map((room:Room) => room.room_Name);
    return !roomNames.includes('Kitchen') || !roomNames.includes('Bathroom');
  }

  toggleSelectAll(event: any, roomIndex: number) {
    const checked = event.target.checked;
    this.Rooms_Devices[roomIndex].room_Devices.forEach((item: any) => {
      item.is_Checked = checked;
      if (checked) {
        if (!this.Devices.find((device: any) => device.item === item && device.roomIndex === roomIndex)) {
          this.Devices.push({ roomIndex: roomIndex, item: item });
        }
      }
    });
  }


  updateCheckedItems(item: any, roomIndex: number,deviceIndex:number) {
    if (!item.is_Checked) {
      this.Rooms_Devices[roomIndex].room_Devices[deviceIndex].is_Checked=false;
      this.Rooms_Devices[roomIndex].room_Devices[deviceIndex].device_Description='';
    }
  }


  updateSelectedItems(roomIndex: number) {
    this.Rooms_Devices[roomIndex].room_Devices = this.Rooms_Devices[roomIndex].room_Devices.filter((item: any) => item.is_Checked);
  }


  createNewField(roomIndex: number) {
    const newItem: any = { device_Name: 'New Field', device_Description: '' };
    this.Rooms_Devices[roomIndex].room_Devices.push(newItem);
  }


  removeField(roomIndex: number, itemIndex: number) {
    const removedItem = this.Rooms_Devices[roomIndex].room_Devices.splice(itemIndex, 1)[0];
    this.Devices = this.Devices.filter((device: any) => !(device.item === removedItem && device.roomIndex === roomIndex));
  }


  checkValidData() {
    if (this.PostBackupInfo.invalid) {
      Object.values(this.PostBackupInfo.controls).forEach(control => {
        control.markAsTouched();
      });

      this.PostBackupInfo.setErrors({ 'required': true });
      return
    }
  }
  Create_PostBackupInfo(data: any) {
    console.log
//     this.Rooms_Devices=[];
//     for(let i=0;i<this.rooms.length;i++)
//     {
//       let itemDevices=[];
//       for(let j=0;j<this.Devices.length;j++)
//       {if(this.Devices[j]?.roomIndex===i)
//       {
//         let device=this.Devices[j]?.item;
//         itemDevices.push(device) }
//       }
//     this.Rooms_Devices.push({
//       room_ID:JSON.parse(localStorage.getItem('apartmentResponse')!).rooms_IDs[i],
//       room_Name: JSON.parse(localStorage.getItem('apartmentResponse')!).rooms_Names[i],
//       room_Devices: itemDevices
//       });
//       itemDevices=[]
//     }


    const payloadData: any = {
      ...data.value,
      "apartment_Addons_Fields": this.inputField,
      "apartment_Rooms_Devices": this.Rooms_Devices
    }

    localStorage.setItem("PostBackupInfo", JSON.stringify({ ...payloadData, CreateapartmentCurrentlyExisting: this.CreateapartmentCurrentlyExisting }))
    this.checkValidData()

    this.subscriptions.push( this._ApartmentService.createPostSec4(payloadData).subscribe((res) => {
      localStorage.removeItem('create_Apart_Equ');
      localStorage.removeItem('BathroomNo');
      localStorage.removeItem('apartmentResponse');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: `${res.message}` });
      this.router.navigate(['apartments']);
    }, (err: any) => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: `${ err.error.message[0]}` });
    }));

  }
  saveInputField(value: any): void {
    this.inputField.push(value)
  }
  message:any
  preview:any
  progress:any
  selectedFiles?: FileList;
  ListFiles:any=[]
  imageList:any={}
  urls = new Array<string>();

  counter: number = 0;
  selectFile(event: any): void {
    this.message = '';
    this.preview = '';
    this.progress = 0;
    this.selectedFiles = event.target.files;

    let files = event.target.files;

    if (files) {
      if (this.counter + files.length > 4) {
        this.message = 'Only a maximum of 4 files are allowed.';
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `${this.message}`,
        });
      } else {
        for (let file of files) {
          this.ListFiles.push(file);
          this.counter += 1;
          let reader = new FileReader();
          reader.onload = (e: any) => {
            this.urls.push(e.target.result);
          };
          reader.readAsDataURL(file);
        }
        this.upload();
      }
    }
    this.ListFiles = [];
  }

  display22="none"

  oncloseModal() {
this.display22="none"

  }
  imageSize:any
  opencloseModal(photo:any) {
    this.display22="block"
   this.imageSize=photo
      }
      openModelImage(photo:any) {
        this.display22="block"
       this.imageSize=photo
          }
      removeItem(imageName:any){


        let index2343 = this.apt_imgs.findIndex((element:any) => element   == imageName);
        this.apt_imgs.splice(index2343, 1);

       //  this.ListFiles.splice(index2343, 1);
        this.urls.splice(index2343, 1);
         }
isSelected=true;
      selected(flie:any,sel:any){
        if(sel=="select"){
          this.isSelected=false;

        }else{
          this.isSelected=true;
        }
      }

      checkValue(event: any,file:any){

          if(event.target.checked==true){

          }else{

          }
         }
isShow=false;
storedImages:any

         onChange(deviceValue:any) {
          if(deviceValue=="Apartment"){
              this.isShow=true
          }
          else{
            this.isShow=false

          }
       }
       spinner: boolean = false;

       upload(): void {
        this.spinner=true;

        this.subscriptions.push(  this.uploadService.uploadMultiFile(this.convertFileToFormData(this.ListFiles)).subscribe(data => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: `${'Images Upload Successfully'}` });

          for (let file of data) {
            this.apt_imgs.push( file.name);
          }
          // this.generalInfoForm.get('apt_ThumbImg')?.patchValue(data[0].name);
          this.PostBackupInfo.get('apartment_Damages_Imgs')?.patchValue(this.apt_imgs);
          localStorage.setItem("imagesAPT11", JSON.stringify(this.apt_imgs));
          this.spinner=false;

        }));

              }
              convertFileToFormData(files: any[]) {
                const formData = new FormData();

                for (let i = 0; i < files.length; i++) {
                  formData.append('Files', files[i], files[i].name);
                }

                return formData;
              }
              apt_imgs: Array<any> = [];
              /** uploadedFiles */
              uploadedFiles: any[] = [];

              ngOnDestroy() {
                for(let i=0;i<this.subscriptions.length;i++)
                this.subscriptions[i].unsubscribe();
              }






////////////////////file upload////////////////
kitchenPhotos: string[] = [];
bathroomPhotos: string[] = [];
bedroom1Photos: string[] = [];
livingRoomPhotos:string[]=[]

Q1kitchen: string[] = [];
Q2kitchen: string[] = [];
Q3kitchen: string[] = [];
Q4kitchen:string[]=[]
Q5kitchen: string[] = [];
Q6kitchen: string[] = [];
Q7kitchen: string[] = [];
Q8kitchen:string[]=[]

onKitchenPhotosUpload(event: any) {
  const files: File[] = event.files;

  files.forEach(file => {
    const formData = new FormData();
    formData.append('fileData', file);

    this.uploadService.uploadSingleFile(formData).subscribe({
      next: (res: any) => {
        const fileUrl = res[0]?.file_Path;
        if (fileUrl) {
          this.kitchenPhotos.push(fileUrl); // ⬅️ خزّن الرابط
        }
      },
      error: (err) => console.error('Upload failed', err)
    });
  });
}


logImages() {
  console.log('Kitchen Photos:', this.kitchenPhotos);
  console.log('Bathroom Photos:', this.bathroomPhotos)
  console.log('Bedroom 1 Photos:', this.bedroom1Photos);
  
  console.log('Living Room Photos:', this.livingRoomPhotos);
}
//////////////////////////////////////question////////////////////////////////////////////////////////
 form!: FormGroup;
  selectedOption: string | null = null;

  
  onAnswerChange(value: string) {
    this.selectedOption = value;
  }

  ////////// text area
  get descriptionLength(): number {
    const value = this.form.get('description')?.value || '';
    // Remove extra spaces + split by space
    const words = value.trim().split(/\s+/);
    return value.trim() === '' ? 0 : words.length;
  }

  checkWordLimit() {
    const control = this.form.get('description');
    const value = control?.value || '';
    const words = value.trim().split(/\s+/);

    if (words.length > 100) {
      // لو زاد، احذف الكلمات الزيادة
      control?.setValue(words.slice(0, 100).join(' '));
    }
  }

      
  
  // لكل غرفة (kitchen, bathroom...)
roomQuestions:any = {
  kitchen: [
    {
      id: 'Q1',
      question: 'Are all cabinets and drawers in good condition?',
      answer: '', // yes | no
      comment: '',
      images: <string[]>[]
    },
    {
      id: 'Q2',
      question: 'Is the sink working properly without leaks?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
     {
      id: 'Q3',
      question: 'Are all appliances (stove, oven, hood, etc.) functioning?',
      answer: '', // yes | no
      comment: '',
      images: <string[]>[]
    },
    {
      id: 'Q4',
      question: 'Are all windows opening and closing smoothly ?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
     {
      id: 'Q5',
      question: 'Is the heating system working correctly?',
      answer: '', // yes | no
      comment: '',
      images: <string[]>[]
    },
    {
      id: 'Q6',
      question: 'Is the ceiling in good condition (no leaks or cracks)?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
     {
      id: 'Q7',
      question: 'Are the walls in good condition (no cracks or stains)?',
      answer: '', // yes | no
      comment: '',
      images: <string[]>[]
    },
    {
      id: 'Q8',
      question: 'Are the floors in good condition (no damage or stains)?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
     
  ],
  bathroom: [
    {
      id: 'B1',
      question: 'Is the toilet working properly?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
     {
      id: 'B2',
      question: 'Is the sink working properly without leaks?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
       {
      id: 'B3',
      question: 'Is the mirror in good condition?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
        {
      id: 'B4',
      question: 'Are all windows opening and closing smoothly ?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
         {
      id: 'B5',
      question: 'Is the heating system working correctly?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
          {
      id: 'B6',
      question: 'Is the ceiling in good condition (no leaks or cracks)?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
          {
      id: 'B7',
      question: 'Are the walls in good condition (no cracks or stains)?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
           {
      id: 'B8',
      question: 'Are the floors in good condition (no damage or stains)?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
    
  ],
  bedroom:[
          {
      id: 'C1',
      question: 'Is the bed and matters in good condition?',
      answer: '',
      comment: '',
      images:<string[]> []
    },
         {
      id: 'C2',
      question: 'Are all light fixtures working properly?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
         {
      id: 'C3',
      question: 'Are the floors clean and undamaged ?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
          {
      id: 'C4',
      question: 'Are all windows opening and closing smoothly ?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
           {
      id: 'C5',
      question: 'Is the heating system working correctly?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
              {
      id: 'C6',
      question: 'Is the ceiling in good condition (no leaks or cracks)?',
      answer: '',
      comment: '',
      images:<string[]> []
    },
              {
      id: 'C7',
      question: 'Are the walls in good condition (no cracks or stains)?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
    
  ],
  livingRoom:[
                 {
      id: 'D1',
      question: 'Are the walls in good condition (no cracks, stains, or damage)?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
                  {
      id: 'D2',
      question: 'Are the floors clean and undamaged ?',
      answer: '',
      comment: '',
      images:<string[]> []
    },

                    {
      id: 'D3',
      question: 'Are the furniture pieces in good condition?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
                      {
      id: 'D4',
      question: 'Are all windows opening and closing smoothly ?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },

                         {
      id: 'D5',
      question: 'Is the heating system working correctly?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
                          {
      id: 'D6',
      question: 'Is the ceiling in good condition (no leaks or cracks)?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
                              {
      id: 'D7',
      question: 'Are the walls in good condition (no cracks or stains)?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
                              {
      id: 'D8',
      question: 'Are the floors in good condition (no damage or stains)?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
  ]
}



submitHandover(){
  const validation = this.validateAllQuestions();
  if(!validation.ok) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Complete all questions',
      detail: 
          'Please answer all question. Missing: ' +
          validation.errors.slice(0,4).join(', ') +
          (validation.errors.length > 4 ? ' ...' : '')
    });
    return;
  }
  /////////////////////////////////////////////////////////////////
  const apartment_ID = JSON.parse(localStorage.getItem('apartmentResponse')!).uuid;
  const handover_Created_at =new Date().toISOString();

  const getPlaceId = (keyword: string) => {
    // const match = this.roomsHandover?.find((room: any) => {
    //   room.some((device: any) => device.device_Name?.toLowerCase().includes(keyword))
    // });
  const match = this.roomsHandover?.find((room: any) =>
    room.room_Name?.toLowerCase().includes(keyword.toLowerCase())
  );
    return match?.room_ID || crypto.randomUUID();
  };

  const places = [
    {
      place_ID: getPlaceId('Kitchen'),
      place_Name:'Kitchen',
      place_Images:this.kitchenPhotos,
      handover_Questions_Json: JSON.stringify(this.roomQuestions.kitchen)
    },
    {
      place_ID: getPlaceId('bathroom'),
      place_Name:'Bathroom',
      place_Images: this.bathroomPhotos,
      handover_Questions_Json: JSON.stringify(this.roomQuestions.bathroom)
    },
    {
      place_ID: getPlaceId('living'),
      place_Name: 'Living Room',
      place_Images: this.livingRoomPhotos,
      handover_Questions_Json: JSON.stringify(this.roomQuestions.livingRoom)
    },
      // 🛏 Bedrooms with dynamic place name and per-room copy of questions
    ...this.getbedrooms.map((room: any) => ({
      place_ID: room.room_ID,
      place_Name: 'Bedroom (' + room.room_Name + ')',
      place_Images: room.place_Images || [],
      handover_Questions_Json: JSON.stringify(room.questions)
    }))
   ]

   const payload = {
    apartment_ID,
    handover_Created_at,
    places
   }

   console.log('🟢 Final Payload', payload);

   this._ApartmentService.addNewHandover(payload).subscribe({
    next: res => {
      console.log('✅ Sent successfully', res)

              this.messageService.add({ severity: 'success', summary: 'Success', detail: `${ res.message|| 'Handover added Successfuly'}` });
    
    },
    error: err => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: `${ err.message ||'Please try again'}` });
      console.error('❌ Error sending handover', err)
    }
   })
   
}


// get bedrooms() {
//   if (!this.roomsHandover) return [];

//   const bedroomKeywords = ['single', 'double', 'trible', 'shared'];
//   return this.roomsHandover.filter((room: any) => {
//     const name = room.room_Name?.toLowerCase() || '';
//     return bedroomKeywords.some(type => name.includes(type));
//   });
// }

get bedrooms() {
  if (!this.roomsHandover) return [];

  const bedroomKeywords = ['single', 'double', 'trible', 'shared'];
  return this.roomsHandover
    .filter((room: any) => {
      const name = room.room_Name?.toLowerCase() || '';
      return bedroomKeywords.some(type => name.includes(type));
    })
    .map((room: any) => ({
      room_ID: room.room_ID,
      room_Name: room.room_Name,
      place_Images: <string[]>[],
     
    }));
}

private deepClone(obj: any) {
  return JSON.parse(JSON.stringify(obj));
}



////////////////make all questions required//////////////////////
 private questionIsValid(q: Q):boolean {
  if(!q?.answer) return false;

  if(q.answer === 'no'){
    const hasComment = !!q.comment?.trim();
    const hasImages =!!q.images && q.images.length > 0;
    return hasComment || hasImages;
  }

  return true;
 }

 private validateAllQuestions():{ok: boolean; errors: string[]}{
    const errors: string[] = [];

   const checkSection =(list: Q[], sectionName: string) => {
    const arr = Array.isArray(list) ? list : []; ///protection from undefined
    arr.forEach((q, idx) => {
      const valid = this.questionIsValid(q);
      q.__invalid=!valid;

      if(!valid) errors.push(`${sectionName} → ${'Q' + (idx + 1)}`)
    });
   };

    checkSection(this.roomQuestions.kitchen as Q[], 'Kitchen');
    checkSection(this.roomQuestions.bathroom as Q[], 'Bathroom');
    checkSection(this.roomQuestions.livingRoom as Q[], 'Living Room');


    this.getbedrooms.forEach((room: any) => {
      checkSection(room.questions as Q[], `Bedroom (${room.room_Name})`);
    })


    return {ok: errors.length === 0, errors};


 }
  
///////////////fill handover section with data coming from details////////////////////////////
// خليه عندك مرة واحدة
private readonly bedroomKeywords = ['bedroom', 'single', 'double', 'triple', 'trible', 'shared'];

private applyHandoverResponse(handover: any) {
  const places: any[] = handover?.places ?? [];

  const parseQuestions = (place: any) => {
    // خُد questions لو موجودة، وإلا فكّ handover_Questions_Json
    let src = Array.isArray(place?.questions) ? place.questions : [];
    if (!src?.length && typeof place?.handover_Questions_Json === 'string') {
      try {
        const parsed = JSON.parse(place.handover_Questions_Json);
        src = Array.isArray(parsed) ? parsed : Object.values(parsed || {});
      } catch {
        src = [];
      }
    }
    // طَبّع الشكل
    return (src || []).map((q: any) => ({
      id: String(q?.id ?? q?.key ?? q?.code ?? crypto.randomUUID()),
      question: String(q?.question ?? q?.text ?? ''),
      answer: String(q?.answer ?? q?.value ?? ''), // مهم للراديوهات
      comment: String(q?.comment ?? q?.note ?? ''),
      images: Array.isArray(q?.images) ? q.images : [],
      __invalid: false
    }));
  };

  const findByName = (needle: string) =>
    places.find(p => (p?.place_Name || '').toLowerCase().includes(needle.toLowerCase()));

  // ===== Kitchen =====
  const kitchen = findByName('kitchen');
  if (kitchen) {
    this.kitchenPhotos = kitchen.place_Images ?? [];
    this.roomQuestions.kitchen = parseQuestions(kitchen);
  }

  // ===== Bathroom =====
  const bathroom = findByName('bathroom');
  if (bathroom) {
    this.bathroomPhotos = bathroom.place_Images ?? [];
    this.roomQuestions.bathroom = parseQuestions(bathroom);
  }

  // ===== Living Room =====
  const living = findByName('living');
  if (living) {
    this.livingRoomPhotos = living.place_Images ?? [];
    this.roomQuestions.livingRoom = parseQuestions(living);
  }

  // ===== Bedrooms من الـ response فقط =====
  const bedrooms = places.filter(p => {
    const name = (p?.place_Name || '').toLowerCase();
    return this.bedroomKeywords.some(k => name.includes(k));
  });

  const extractBedroomName = (placeName: string) => {
    // يحوّل "Bedroom (Single)" -> "Single" أو "Bedroom 1" -> "#1"
    const m1 = placeName?.match(/Bedroom\s*\((.*?)\)/i);
    if (m1?.[1]) return m1[1].trim();
    const m2 = placeName?.match(/Bedroom\s*(\d+)/i);
    if (m2?.[1]) return `#${m2[1]}`;
    return placeName?.replace(/Bedroom/i, '').trim() || placeName || 'Bedroom';
  };

  this.getbedrooms = bedrooms.map(p => ({
    room_ID: p.place_ID,
    room_Name: extractBedroomName(p.place_Name || 'Bedroom'),
    place_Images: Array.isArray(p.place_Images) ? p.place_Images : [],
    questions: parseQuestions(p),
    comment: p?.comment ?? ''
  }));
}

 


}
